import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NavigationLink } from '@domgen/dgx-fe-common';
import { Icon, IconComponent } from '@domgen/dgx-fe-components/icon';
import { RichTextComponent } from '@domgen/dgx-fe-components/content';
import { LinkComponent } from '@domgen/dgx-fe-components/navigation';
import { NgIf } from '@angular/common';
import { PanelComponent } from '@domgen/dgx-fe-components/panel';

@Component({
  selector: 'support-contact-us-panel',
  templateUrl: './contact-us-panel.component.html',
  styleUrls: ['./contact-us-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PanelComponent,
    NgIf,
    IconComponent,
    LinkComponent,
    RichTextComponent,
  ],
})
export class ContactUsPanelComponent {
  @Input() body?: string;
  @Input() icon?: Icon;
  @Input() link?: NavigationLink;
  @Input() title?: string;
}
